import SHEnumShow from './src/show.vue';

/* istanbul ignore next */
SHEnumShow.install = function(Vue) {
  Vue.component('sh-enum-show', SHEnumShow);
};

export default SHEnumShow;



// WEBPACK FOOTER //
// ./src/components/base/view/Enum/cmps/show/index.js